module.exports = __webpack_public_path__ + "taurus-74aede579bcdb747ff0d.png";